<template>
  <div class="view-mode-toggle">
    <themed-button 
      @click="$emit('input', 'grid')"
      :variant="value === 'grid' ? 'default' : 'outline'"
      size="icon"
      :aria-label="gridLabel"
      :aria-pressed="value === 'grid'"
    >
      <theme-icon icon="grid-icon" type="icons" classes="flex" />
    </themed-button>
    
    <themed-button 
      @click="$emit('input', 'list')"
      :variant="value === 'list' ? 'default' : 'outline'"
      size="icon"
      :aria-label="listLabel"
      :aria-pressed="value === 'list'"
    >
      <theme-icon icon="list-icon" type="icons" classes="flex" />
    </themed-button>
  </div>
</template>

<script>
import ThemedButton from './ThemedButton.vue';
import ThemeIcon from './ThemeIcon.vue';

export default {
  name: 'ViewModeToggle',
  
  components: {
    ThemedButton,
    ThemeIcon
  },
  
  props: {
    value: {
      type: String,
      default: 'grid',
      validator: (v) => ['grid', 'list'].includes(v)
    },
    gridLabel: {
      type: String,
      default: 'Grid View'
    },
    listLabel: {
      type: String,
      default: 'List View'
    }
  }
};
</script>
